/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sit with your wrists straight and elbows at roughly 90 degrees — awkward angles tire your hands faster than typing itself does. Keep your shoulders relaxed and take the test somewhere you can maintain steady posture for the full 5 minutes; technique matters more at this length than at 1 minute.`)
};

const es_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siéntate con las muñecas rectas y los codos a unos 90 grados — los ángulos incómodos cansan tus manos más rápido que la propia escritura. Mantén los hombros relajados y haz el test en un lugar donde puedas mantener una postura estable durante los 5 minutos completos; la técnica importa más a esta duración que en 1 minuto.`)
};

const de_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitze mit geraden Handgelenken und Ellbogen in etwa 90-Grad-Winkel — ungünstige Winkel ermüden deine Hände schneller als das Tippen selbst. Halte deine Schultern entspannt und mach den Test an einem Ort, an dem du die vollen 5 Minuten über eine stabile Haltung bewahren kannst — bei dieser Länge zählt die Technik mehr als bei 1 Minute.`)
};

const nl_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zit met je polsen recht en je ellebogen in ongeveer een hoek van 90 graden — ongemakkelijke hoeken vermoeien je handen sneller dan het typen zelf. Houd je schouders ontspannen en doe de test op een plek waar je de volledige 5 minuten een stabiele houding kunt aanhouden; techniek is bij deze duur belangrijker dan bij 1 minuut.`)
};

const fr_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asseyez-vous avec les poignets droits et les coudes à environ 90 degrés — les angles inconfortables fatiguent vos mains plus vite que la frappe elle-même. Gardez les épaules détendues et faites le test dans un endroit où vous pouvez maintenir une posture stable pendant les 5 minutes complètes ; la technique compte plus à cette durée qu'à 1 minute.`)
};

const it_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siediti con i polsi dritti e i gomiti a circa 90 gradi — angoli scomodi stancano le mani più velocemente della digitazione stessa. Tieni le spalle rilassate e fai il test in un posto dove puoi mantenere una postura stabile per tutti i 5 minuti; a questa durata la tecnica conta più che a 1 minuto.`)
};

const pt_br2_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sente-se com os pulsos retos e os cotovelos a aproximadamente 90 graus — ângulos desconfortáveis cansam suas mãos mais rápido do que a própria digitação. Mantenha os ombros relaxados e faça o teste em um lugar onde você consiga manter a postura firme pelos 5 minutos inteiros; a técnica importa mais nessa duração do que em 1 minuto.`)
};

const pt_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sente-se com os pulsos direitos e os cotovelos a cerca de 90 graus — ângulos desajeitados cansam as suas mãos mais depressa do que a própria escrita. Mantenha os ombros relaxados e faça o teste num local onde consiga manter uma postura estável durante os 5 minutos completos; a técnica importa mais a esta duração do que num teste de 1 minuto.`)
};

const ja_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手首をまっすぐにし、肘はおよそ90度になるように座りましょう — 不自然な角度は、タイピングそのものよりも早く手を疲れさせます。肩の力を抜き、5分間ずっと安定した姿勢を保てる場所でテストを受けてください。この長さでは、1分間のときよりもフォームが重要になります。`)
};

const zh_typing_u5_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`坐姿应保持手腕伸直，手肘约呈90度 — 不当的角度会比打字本身更快地使双手疲劳。保持肩膀放松，在能够维持整整5分钟稳定姿势的地方进行测试；在这个时长下，姿势技巧比1分钟测试更重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u5_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u5_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u5_faq4_a", locale)
	if (locale === "en") return en_typing_u5_faq4_a(inputs)
	if (locale === "es") return es_typing_u5_faq4_a(inputs)
	if (locale === "de") return de_typing_u5_faq4_a(inputs)
	if (locale === "nl") return nl_typing_u5_faq4_a(inputs)
	if (locale === "fr") return fr_typing_u5_faq4_a(inputs)
	if (locale === "it") return it_typing_u5_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u5_faq4_a(inputs)
	if (locale === "pt") return pt_typing_u5_faq4_a(inputs)
	if (locale === "ja") return ja_typing_u5_faq4_a(inputs)
	return zh_typing_u5_faq4_a(inputs)
};